/**
 * Mobile-only bottom navigation bar for logged-in users.
 * Hidden on >= md breakpoint (desktop keeps sidebar).
 */
import { useLocation, useNavigate } from "react-router-dom";
import { Home, FileText, Plus, MessageSquare, CalendarDays } from "lucide-react";

export const MobileBottomNav = ({ language = "en" }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const items = [
    { id: "home", icon: Home, label_de: "Start", label_en: "Home", to: "/dashboard" },
    { id: "requests", icon: FileText, label_de: "Anfragen", label_en: "Requests", label_fr: "Demandes", label_it: "Richieste", to: "/dashboard/jobs" },
    { id: "fab", icon: Plus, label_de: "Neu", label_en: "New", label_fr: "Nouveau", label_it: "Nuovo", to: "/dashboard/jobs/new", primary: true },
    { id: "messages", icon: MessageSquare, label_de: "Nachrichten", label_en: "Messages", label_fr: "Messages", label_it: "Messaggi", to: "/dashboard/messages" },
    { id: "appointments", icon: CalendarDays, label_de: "Termine", label_en: "Appointments", label_fr: "Rendez-vous", label_it: "Appuntamenti", to: "/dashboard/appointments" },
  ];

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-white/10"
      style={{
        background: "rgba(10, 26, 62, 0.95)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around px-2 py-2">
        {items.map(it => {
          const Icon = it.icon;
          const active = pathname === it.to || (it.to !== "/dashboard" && pathname.startsWith(it.to));
          const label = it[`label_${language}`] || it.label_en;
          if (it.primary) {
            return (
              <button
                key={it.id}
                onClick={() => navigate(it.to)}
                className="-mt-6 w-14 h-14 rounded-full bg-[#0044CC] hover:bg-[#0055EE] flex items-center justify-center shadow-lg shadow-blue-500/40 transition-all active:scale-95"
                data-testid={`bottom-nav-${it.id}`}
              >
                <Icon className="w-6 h-6 text-white" strokeWidth={2.5} />
              </button>
            );
          }
          return (
            <button
              key={it.id}
              onClick={() => navigate(it.to)}
              className={`flex flex-col items-center gap-0.5 px-3 py-1.5 transition-colors ${
                active ? "text-[#60a5fa]" : "text-blue-100/60 hover:text-white"
              }`}
              data-testid={`bottom-nav-${it.id}`}
            >
              <Icon className="w-5 h-5" strokeWidth={active ? 2.5 : 2} />
              <span className="text-[10px] font-medium leading-none">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
